export default "__VITE_ASSET__Bh8ieyEU__"